<div phx-floating-button>
  <ng-content></ng-content>
</div>
